import { EyePlusIcon } from './EyePlusIcon';

/**
 * author: GreenTurtwig
 * id 644FD0C7-1B46-48D8-A410-FDA22E63BFCF
 * name eye-plus
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-plus.svg
 * tags
 */
export const EyeAddIcon = EyePlusIcon;
export default EyeAddIcon